import { enumBranchStyle } from "../constants";

export function IsLeftStyle(branchStyle) {
  var rightStyle = false;
  switch (branchStyle) {
    case enumBranchStyle.onecolumncenterleft:
    case enumBranchStyle.onecolumnleft:
    case enumBranchStyle.assistantpeerleft:
    case enumBranchStyle.assistantleft:
      rightStyle = true;
      break;
  }

  return rightStyle;
}
